import React, { Component } from 'react';
import { Grid, Header } from 'semantic-ui-react';
import classes from './PaymentInformation.css';
import { gciPageView } from '../../../lib/analytics';

const pageTitle = 'Subscription Renewal';

class RenewSubscription extends Component {
  componentDidMount() {
    document.title = `${pageTitle} - TheHuddle`;
    gciPageView(pageTitle);
  }

  render() {
    return (
      <Grid columns={16} className={classes.PaymentInformation}>
        <Grid.Row>
          <Grid.Column width={16}>
            <Header className={classes.header} as="h1">
              {pageTitle}
            </Header>
            <p>
              The Huddle is no longer accepting subscription renewals.
              If you have questions about your account, please <a href="https://thehuddle.com/contact-us/">contact us</a>.
            </p>
            <div className={classes.moreOptionsLinks}><a href="/logout">Sign out</a></div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default RenewSubscription;



// WEBPACK FOOTER //
// ./src/app/views/PaymentInformation/RenewSubscription.js